import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { ShareholdersResource } from '../../../services/resources/shareholders.resource';

@Component({
    selector: 'sl-address-dialog',
    templateUrl: './address-dialog.component.html',
    styleUrls: ['./address-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AddressDialogComponent {
    readonly data = inject(MAT_DIALOG_DATA);

    private readonly dialogRef = inject(MatDialogRef<AddressDialogComponent>);
    private readonly shareholderResource = inject(ShareholdersResource);

    onSave(): void {
        this.shareholderResource.updateAddress(this.data.id, this.data.address).subscribe(result => {
            if (result.value.isSuccessful) {
                this.dialogRef.close(this.data.address);
            }
        });
    }
}
